@if (!isMobile) {
    <p-table 
        #dt
        [columns]="visibleColumns"
        [value]="list"
        dataKey="fiscalYearId"
        [rowHover]="true"
        [rows]="50"
        [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10, 25, 50, 100, 200]"
        [loading]="isLoading"
        [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="500"
        [size]="'large'"
        stripedRows 
        sortField="endDate"
        sortOrder="-1"
        selectionMode="single"    
        [globalFilterFields]='searchColumns'
        [dt]="tableDts"
        [scrollable]="true"
        scrollHeight="650px"
    >

        <ng-template #caption>
            <div class="d-flex">
                @if (baService.isBaAdmin()) {
                    <p-button 
                        icon="pi pi-plus"
                        label="Add Fiscal Year" 
                        (click)="createFiscalYear()" 
                        class="pr-1"
                    />
                }

                <p-multiselect 
                    class="pl-1"
                    display="chip" 
                    [options]="availableColumns" 
                    [(ngModel)]="visibleColumns" 
                    optionLabel="header" 
                    selectedItemsLabel="Show / Hide" 
                    [style]="{ 'min-width': '100px' }" 
                    placeholder="Choose Columns" 
                    (ngModelChange)='columnChange($event)'
                />

                <p-button 
                    class="pl-1"
                    (click)="op.toggle($event)" 
                    icon="pi pi-info-circle" 
                    label="Legend" 
                    severity="help"
                />
                <p-popover #op>
                    @for (legendVm of legend; track legendVm.id) {
                        <div class='d-flex align-items-center'>
                            <div 
                                class='square' 
                                [ngStyle]="{'background-color': legendVm.colorCode}"
                            ></div>
                            <span> = {{ legendVm?.description }}</span>
                        </div>
                    }
                </p-popover>

                <p-button 
                    class="pl-1"
                    (click)="opp.toggle($event)" 
                    icon="pi pi-search" 
                    label="Filters" 
                    severity="warn"
                />
                <p-popover #opp>
                    <div>
                        <label class='for'>Is Active?</label>
                        <mat-button-toggle-group 
                            #isActiveFilter
                            [(ngModel)]="filters.isActive" 
                            [value]="filters.isActive"
                            (change)="
                                this.filters.isActive = $event.value; 
                                getList();
                            "
                        >
                            <mat-button-toggle 
                                class="flex-fill" 
                                [value]="true"
                            >Yes</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill mx-2" 
                                [value]="false"
                            >No</mat-button-toggle>
                            <mat-button-toggle 
                                class="flex-fill" 
                                value="null"
                            >All</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </p-popover>

                <p-iconfield 
                    iconPosition="right" 
                    class="ml-auto"
                >  
                    <p-inputicon>
                        <i class="pi pi-search pl-2"></i>
                    </p-inputicon>
                    <input 
                        #searchValue
                        pInputText 
                        type="text" 
                        (input)="dt.filterGlobal($event.target.value, 'contains')" 
                        placeholder="Search..." 
                    />
                    <p-button 
                        class="pl-1"
                        label="Clear" 
                        [outlined]="true" 
                        icon="pi pi-filter-slash" 
                        (click)="clearFilters(dt, searchValue)" 
                    />
                </p-iconfield>            
            </div>
        </ng-template>

        <ng-template 
            #header
            let-columns
        >
            <tr>
                @for (col of columns; track col; let i = $index) {
                    <th 
                        [pSortableColumn]="col?.canSort ? $safeNavigationMigration(col?.field) : null" 
                        [class]="col?.cellClass"
                    >
                        {{ col?.header }} 
                        @if (col?.canSort) { <p-sortIcon [field]="$safeNavigationMigration(col?.field)" /> }
                    </th>
                }
            </tr>
        </ng-template>

        <ng-template 
            #body 
            let-row
            let-columns="columns"
        >
            <tr 
                [pSelectableRow]="row" 
                (click)="openModal(row)"
            >
                @for (col of columns; track col) {
                    <td 
                        [class]="col?.cellClass"
                        [ngStyle]="{'background-color': getRowColor(row)}"
                    >{{ row[col?.field] }}</td>
                }
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td 
                    colspan="5" 
                    class="text-center"
                >No records found.</td>
            </tr>
        </ng-template>

    </p-table>
} @else {
    <div class="d-flex mb-2 pl-3 pr-3">
        @if (baService.isBaAdmin()) {
            <p-button 
                icon="pi pi-plus"
                label="" 
                (click)="createFiscalYear()" 
            />
        }

        <p-button 
            class="pl-1"
            (click)="op.toggle($event)" 
            icon="pi pi-info-circle" 
            label="" 
            severity="help"
        />
        <p-popover #op>
            @for (legendVm of legend; track legendVm.id) {
                <div class='d-flex align-items-center'>
                    <div 
                        class='square' 
                        [ngStyle]="{'background-color': legendVm.colorCode}"
                    ></div>
                    <span> = {{ legendVm?.description }}</span>
                </div>
            }
        </p-popover>

        <p-button 
            class="pl-1"
            (click)="opp.toggle($event)" 
            icon="pi pi-search" 
            label="" 
            severity="warn"
        />
        <p-popover #opp>
            <div>
                <label class='for'>Is Active?</label>
                <mat-button-toggle-group 
                    #isActiveFilter
                    [(ngModel)]="filters.isActive" 
                    [value]="filters.isActive"
                    (change)="
                        filters.isActive = $event.value; 
                        getList();
                    "
                >
                    <mat-button-toggle 
                        class="flex-fill" 
                        [value]="true"
                    >Yes</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill mx-2" 
                        [value]="false"
                    >No</mat-button-toggle>
                    <mat-button-toggle 
                        class="flex-fill" 
                        value="null"
                    >All</mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </p-popover>
    </div>

    @if (list?.length == 0) { <div class="text-center">No Records</div> }

    @for (row of list; track row) {
        <div class="mb-4 flex items-center justify-center">
            <p-card class="p-card pl-3 pr-3">
                <ng-template #header>
                    <div 
                        class="pb-2 p-card-header" 
                        [ngStyle]="{'background-color': getRowColor(row)}"
                    >
                        <h3 class="text-center">{{ row.fiscalYearName }}</h3>
                    </div>
                </ng-template>

                <div>
                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Start Date:</div>
                        <div class="col-md-6 text-right">{{ row.startDate | date:'M/d/yyyy' }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">End Date:</div>
                        <div class="col-md-6 text-right">{{ row.endDate | date:'M/d/yyyy' }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Is Active:</div>
                        <div class="col-md-6 text-right">{{ row.isActiveStr }}</div>
                    </div>

                    <div class="row pb-1">
                        <div class="col-md-6 text-left">Is Current:</div>
                        <div class="col-md-6 text-right">{{ row.isCurrentStr }}</div>
                    </div>
                </div>

                <ng-template #footer>
                    <div class="row">
                        <div class="col-md-6 text-left">
                            <p-button 
                                icon="pi pi-external-link"
                                label="Edit" 
                                severity="info" 
                                (click)="
                                    $event.stopPropagation(); 
                                    openModal(row);
                                "
                            />
                        </div>

                        <div class="col-md-6 text-right">                            
                        </div>
                    </div>
                </ng-template>
            </p-card>
        </div>
    }
}

<ng-template 
    #fiscalYearModal 
    let-modal
>
    <form [formGroup]="formGroup">
        <div class="modal-header align-items-center">
            <h5 class="modal-title">{{id == 0 ? "Create": "Edit"}} Fiscal Year</h5>
            <div class="d-flex">
                @if (id !== 0) {
                    <div id="pageActions">
                        <button 
                            pcg-svg-history 
                            (click)="
                                auditHistoryService.openAuditHistory(
                                    id
                                    , 'BA.Models.BA_FiscalYearVm'
                                    , 'B&A Fiscal Years'
                                    , 'ba/admin/fiscal-years/audit-history/'
                                ); 
                                modalService?.dismissAll();
                            " 
                            ngbTooltip="Audit History" 
                            class="page-action"
                        ></button>
                    </div>
                } @else {
                    <button 
                        type="button" 
                        class="fa-close close" 
                        aria-label="Close" 
                        (click)="modal.dismiss()"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button> 
                }
            </div>
        </div>

        <div class="modal-body">
            <div class="row">
                <pcg-control-group 
                    class="col-md-12" 
                    label="Start Date"
                >
                    <input 
                        type="date" 
                        pcgControlRef 
                        formControlName="startDate" 
                        placeholder="MM/dd/yyyy" 
                        class="form-control" 
                        maxlength="10" 
                        [ngModel]="formGroup.controls.startDate.value | date:'yyyy-MM-dd'"
                    />
                </pcg-control-group>
            </div>

            <div class="row">
                <pcg-control-group 
                    class="col-md-12" 
                    label="End Date"
                >
                    <input 
                        type="date" 
                        pcgControlRef 
                        formControlName="endDate" 
                        placeholder="MM/dd/yyyy" 
                        class="form-control" 
                        maxlength="10" 
                        [ngModel]="formGroup.controls.endDate.value | date:'yyyy-MM-dd'"
                    />
                </pcg-control-group>
            </div>

            <div class="row align-items-center">
                @if (isActive){
                    <pcg-control-group 
                        class="col-md-8" 
                        label="Is Current Fiscal Year"
                    >
                        <ui-switch 
                            #isCurrent 
                            pcgControlRef
                            color='#007bff'
                            defaultBgColor='#EEE' 
                            class='ml-2 mt-2'
                            size='small' 
                            formControlName='isCurrent'
                        ></ui-switch>
                    </pcg-control-group>
                }

                @if (id > 0) {
                    <div  
                        class="row"
                        [ngClass]="{ 'col-md-4': isActive, 'col-md-12 justify-content-end text-right': !isActive }"
                    >
                        <div class="pr-0">
                            <p 
                                [class.text-danger]="!isActive" 
                                [class.d-none]="isActive"
                                class="txt-activate"
                            >This Fiscal Year is deactivated.</p>
                            @if (id !== 0) {
                                <a 
                                    [class.btn-danger]="isActive" 
                                    [class.btn-save]="!isActive" 
                                    class="btn btn-sm btn-activate" 
                                    (click)="activateDeactivate()"
                                >{{ isActive ? 'Deactivate' : 'Reactivate' }}</a>
                            }
                        </div>
                    </div>
                }
            </div>            
        </div>

        <div class="modal-footer">
            <button     
                type="button" 
                class="btn btn-secondary btn-cancel" 
                (click)="modal.dismiss()"
            >Cancel</button>
            <button 
                type="button" 
                class="btn btn-primary btn-save" 
                (click)="saveForm()"
            >Save</button>
        </div>
    </form>
</ng-template>